import React from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import imgMain from "../../Assets/img/Group 2667.svg";

function NotFound() {
  return (
    <div className="NotFound innerBody">
      <Header />
      <div className="container">
        <div className="row Unauthorised">
          <div className="col text-center">
            
            <div className="mt-2"><br/> <br/> <br/><img src={imgMain} alt="" className="img-main" /> </div>

            <h3 className="ml-auto mr-auto text-center pt-4">
              Unauthorised Level Attempt
            </h3>
            <p className="mt-4 col-8 text-center offset-2 text-white">
             Looks like you are attempting to access a level which you do not have access to at the moment. To complete the game, you need to solve the levels in the proper sequence.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col text-center mb-4">
         
            
            <div className="pt-2 pb-4">
              <button className="btn btn-yellow g-recaptcha"> GO BACK </button>
            </div>
          
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
